<template>
  <div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
      @close="onClose"
    >
      <el-form
        ref="form"
        label-width="120px"
        :model="form"
        :rules="rules"
        style="max-height: calc(100vh - 280px);overflow-y: auto;padding: 15px"
      >
        <el-form-item label="内容标题：" prop="Title">
          <el-input
            placeholder="标题"
            v-model="form.Title"
            clearable
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="文章分类：" prop="TypeCode">
          <el-cascader
            ref="cascaderType"
            style="width: 100%"
            v-model="form.TypeCode"
            :options="options"
            :props="{ multiple: true }"
            @change="handleChange"
            clearable
          />
        </el-form-item>
        <el-form-item label="封面图：" prop="HeadImage">
          <p>支持png/jpg/jpeg格式，建议尺寸650X360</p>
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPicPreview"
            @onRemove="onPicRemove"
            @onUpLoad="onPicUpLoad"
            :fileList="pictureList"
            accept="image/*"
            :fixedNumber="[650, 360]"
            :autoCropWidth="650"
            :autoCropHeight="360"
          >
            <div slot="content">
              <i slot="default" class="el-icon-camera-solid"></i>
            </div>
          </of-upload>
          <image-viewer
            v-if="isImage"
            :imageViewerUrl="imageUrl"
            @closeImageViewer="onImageClose"
          />
        </el-form-item>
        <el-form-item label="上传附件：" prop="File">
          <of-upload
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
            class="upload-demo"
            list-type="fileList"
            @onUpLoad="onFileUpLoad"
            @onRemove="onFileRemove"
            @onCheckFile="onCheckFile"
            @onPreview="onFilePreview"
            :limit="10"
            :fileList="fileList"
          >
            <div slot="content">
              <el-button size="mini">
                <i class="el-icon-upload el-icon--left"></i>上传文件
              </el-button>
            </div>
          </of-upload>
          <p>支持扩展名： .rar .zip .doc .docx .pdf .jpg...</p>
        </el-form-item>
        <el-form-item label="摘要：">
          <el-input
            placeholder="摘要"
            v-model="form.Describe"
            clearable
            type="textarea"
            maxlength="500"
            :rows="2"
          />
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发布时间：" prop="ReleaseTime">
              <el-date-picker
                v-model="form.ReleaseTime"
                value-format="timestamp"
                format="yyyy-MM-dd HH:mm"
                type="datetime"
                class="releaseTime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="作者：" prop="Publisher">
              <el-input
                placeholder="作者"
                v-model="form.Publisher"
                clearable
                maxlength="50"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="来源：" prop="PublishSource">
               <el-input
                  placeholder="来源"
                  v-model="form.PublishSource"
                  clearable
                  maxlength="10"
                  />
        </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发布形式：" prop="ReleaseStatus">
              <el-radio-group v-model="form.ReleaseStatus">
                <el-radio :label="0">网页形式</el-radio>
                <el-radio :label="1">链接形式</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="链接地址："
          prop="LinkUrl"
          v-if="form.ReleaseStatus === 1"
        >
          <el-input
            placeholder="链接地址"
            v-model="form.LinkUrl"
            clearable
            maxlength="500"
          />
        </el-form-item>
        <el-form-item
          label="内容："
          prop="Abstract"
          v-if="form.ReleaseStatus === 0"
        >
          <of-tinymce
            ref="editor"
            v-model="form.Abstract"
            :height="500"
          ></of-tinymce>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/modules/zjrc/api";
import OfTinymce from "@/components/controls/of_editor/of_tinymce";
import OfUpload from "@/components/controls/of_upload/of_upload";
import ImageViewer from "@/components/controls/of_imageViewer";
import { saveAs } from "file-saver";

export default {
  components: {
    OfTinymce,
    OfUpload,
    ImageViewer,
  },
  data() {
    return {
      title: "",
      dialogVisible: false,
      form: {
        Title: "",
        TypeCode: undefined,
        Describe: "",
        PublishSource: "",
        ReleaseTime: undefined,
        Publisher: "",
        Sort: undefined,
        Abstract: "",
        HeadImage: "",
      },
      rules: {
        Title: {
          required: true,
          max: 100,
          message: "内容标题不能空且长度为100个字内",
          trigger: "blur",
        },
        TypeCode: {
          required: true,
          message: "请选择文章分类",
          trigger: "blur",
        },
        Abstract: {
          required: true,
          message: "文章内容不能空",
          trigger: "blur",
        },
        ReleaseTime: {
          required: true,
          message: "请选择发布时间",
          trigger: "change",
        },
        ReleaseStatus: {
          required: true,
          message: "请选择发布形式",
          trigger: "change",
        },
        LinkUrl: {
          required: true,
          message: "请输入链接地址",
          trigger: "change",
        },
      },
      options: [],
      pictureList: [],
      imageUrl: "",
      isImage: false,
      fileList: [],
      typeCodeList: [],
      typeNameList: [],
    };
  },
  mounted() {
    const vm = this;
    vm.getOptions();
  },
  methods: {
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.form);
          params.ReleaseTime = (params.ReleaseTime / 1000).toFixed(0);
          params.TypeCode = this.typeCodeList.join(",");
          params.TypeName = this.typeNameList.join(",");
          api
            .SaveNews(params)
            .then((res) => {
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("onOk", params);
                this.onClose();
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.isConfirm = false;
            });
        }
      });
    },
    onFileUpLoad(file) {
      if (file.response.Code === 0) {
        const list = {
          name: file.name,
          url: "/files" + file.response.Data.StorePath,
          id: file.response.Data.FileId,
        };
        this.fileList.push(list);
        this.form.File = JSON.stringify(this.fileList);
        this.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    onFileRemove() {
      const vm = this;
      if (Array.isArray(vm.fileList) && vm.fileList.length > 0) {
        vm.form.File = JSON.stringify(this.fileList);
      } else {
        vm.form.File = null;
      }
    },
    onCheckFile(file, status) {
      let size = file.size / 1024 / 1024;
      if (size > 100) {
        this.$message({
          type: "error",
          message: "附件大小必须小于100M",
        });
        status(false);
        return;
      }
    },
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
    onPicUpLoad(file) {
      if (file.Code === 0) {
        this.form.HeadImage = "/files" + file.Data.StorePath;
        this.pictureList = [{ url: this.form.HeadImage }];
        this.$message({
          message: "封面图上传成功",
          type: "success",
        });
      }
    },
    onPicRemove() {
      const vm = this;
      vm.pictureList = [];
      vm.form.HeadImage = null;
    },
    onPicPreview(file) {
      const vm = this;
      vm.imageUrl = file.url;
      vm.isImage = true;
    },
    onImageClose() {
      const vm = this;
      vm.isImage = false;
      vm.imageUrl = "";
    },
    handleChange(list) {
      const vm = this;
      vm.typeCodeList = list.map((x) => x[x.length - 1]);
      const nameList = vm.$refs.cascaderType.getCheckedNodes();
      vm.typeNameList = nameList.map((x) => x.label);
    },
    getOptions() {
      const vm = this;
      api.getNewsTypeOptions().then((res) => {
        if (res.data.Code == 0) {
          vm.options = res.data.Data;
        }
      });
    },
    //加载菜单
    getParentCode(list) {
      const vm = this;
      vm.form.TypeCode = [];
      list.forEach((x) => {
        vm.getNodeKeys(vm.options, x);
      });
    },
    getNodeKeys(rows, key, current = []) {
      const vm = this;
      rows.forEach((x) => {
        let list = JSON.parse(JSON.stringify(current));
        list.push(x.value);
        if (x.children && x.children.length > 0) {
          vm.getNodeKeys(x.children, key, list);
        } else {
          if (x.value == key) {
            vm.form.TypeCode.push(list);
          }
        }
      });
    },
    onClose() {
      const vm = this;
      vm.dialogVisible = false;
      vm.form = {
        Title: "",
        TypeCode: undefined,
        Describe: "",
        PublishSource: "",
        ReleaseTime: undefined,
        Publisher: "",
        Sort: undefined,
        Abstract: "",
        HeadImage: "",
      };
      vm.pictureList = [];
      vm.fileList = [];
      vm.typeCodeList = [];
      vm.typeNameList = [];
    },
    create(id) {
      const vm = this;
      if (id) {
        vm.title = "编辑新闻";
        const param = {
          id: id,
        };
        api.QueryNewsById(param).then((res) => {
          if (res.data.Code === 0) {
            vm.form = res.data.Data;
            vm.typeCodeList = vm.form.TypeCode.split(",");
            vm.typeNameList = vm.form.TypeName.split(",");
            vm.form.ReleaseTime = vm.form.ReleaseTime * 1000;
            if (vm.form.HeadImage) {
              vm.pictureList.push({ url: vm.form.HeadImage });
            }
            if (vm.form.File) {
              vm.fileList = JSON.parse(vm.form.File);
            }
            vm.getParentCode(vm.typeCodeList);
          }
        });
      } else {
        vm.title = "新增新闻";
        vm.form = {
          Title: "",
          TypeCode: undefined,
          Describe: "",
          PublishSource: "",
          ReleaseTime: undefined,
          Publisher: "",
          Sort: undefined,
          Abstract: "",
          HeadImage: "",
        };
      }
      vm.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-upload input[type="file"] {
  display: none !important;
}
.releaseTime {
  /deep/.el-input__icon {
    display: none;
  }
}
</style>
